/**
 * @generated SignedSource<<e5f69f0f90bf5ff0e4f1334bd6ea1980>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignerDirectorySearch_viewer$data = {
  readonly designFirmResults?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string | null;
        readonly publicProfile: {
          readonly urlLabel: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "DesignerDirectorySearch_viewer";
};
export type DesignerDirectorySearch_viewer$key = {
  readonly " $data"?: DesignerDirectorySearch_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignerDirectorySearch_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasSearch"
    },
    {
      "kind": "RootArgument",
      "name": "search"
    },
    {
      "kind": "RootArgument",
      "name": "showOnlyTpnFirms"
    },
    {
      "kind": "RootArgument",
      "name": "showTestFirms"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignerDirectorySearch_viewer",
  "selections": [
    {
      "condition": "hasSearch",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "designFirmResults",
          "args": [
            {
              "kind": "Variable",
              "name": "firmName",
              "variableName": "search"
            },
            {
              "kind": "Variable",
              "name": "showOnlyTpnFirms",
              "variableName": "showOnlyTpnFirms"
            },
            {
              "kind": "Variable",
              "name": "showTestFirms",
              "variableName": "showTestFirms"
            }
          ],
          "concreteType": "DirectoryDesignFirmConnection",
          "kind": "LinkedField",
          "name": "designFirms",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DirectoryDesignFirmEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DirectoryDesignFirm",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DesignFirmPublicProfile",
                      "kind": "LinkedField",
                      "name": "publicProfile",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "urlLabel",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "541788d123116a178ada164f4bd221b0";

export default node;
